module.exports = __webpack_public_path__ + "static/img/list4.013a985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/list4.png
// module id = EFPL
// module chunks = 0